import { z } from "zod";

export const aideFormSchema = z.object({
  motifId: z.string().min(1, "Requis"),
  message: z.string().min(5, "Veuillez détailler votre demande."),
});
export type AideFieldValues = z.infer<typeof aideFormSchema>;
